/*
 * @Description: 运单相关接口
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/8/7 9:10
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host,
  E6_MS_TMS_E6YUN_BASE_WEB,
  E6_MS_TMS_BUSI_WEB,
  E6_MS_TMS_BASE_WEB,
  E6_MS_TMS_CUSTOMER_DMH_WEB
} = e6ModuleOrderWaybillProcessApi;

// 获取电子路书列表，模糊查询
export function fetchRoadBookList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/findFixedBillWay/page`,
    method: "post",
    data
  });
}

// 获取区域列表，模糊查询
export function fetchWaybillAreaList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePosition`,
    method: "post",
    data
  });
}

// 新增电子路书
export function fetchAddWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/saveOrEdit`,
    method: "post",
    data
  });
}

// 运单修改查询详情
export function fetchWaybillDetailInfo(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getWaybillInfoForEdit`,
    method: "get",
    params
  });
}

// 订单匹配
export function fetchOrderListByArea(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/findOrderStowage`,
    method: "post",
    data
  });
}

// 订单匹配
export function fetchOrderDetail(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/findOrderNode`,
    method: "post",
    data
  });
}

//运单节点选择
export function getWaybillNodeList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/getWaybillNodeList`,
    method: "post",
    data
    // {
    //   "corpId": 0
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

//根据节点查询订单信息
export function getNodeOrderInfo(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getNodeOrderInfo`,
    method: "get",
    params
  });
}

//到达某个运单节点
export function arriveWaybillNode(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/arriveWaybillNode`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "time": "2020-08-28T07:13:00.632Z",
    //   "version": 0,
    //   "waybillNodeId": 0
    // }
  });
}

//开始装货
export function startLoad(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/startLoad`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "time": "2020-08-28T07:14:35.236Z",
    //   "version": 0
    // }
  });
}

//手动结束
export function manualEnd(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/manualEnd`,
    method: "post",
    data
    // {
    //   "assignVehicle": true,
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "remark": ""
    //   "version": 0
    // }
  });
}

//离开节点信息
export function getLeaveNodeInfoList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/getLeaveNodeInfoList`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

//确认离开
export function leaveWaybillNode(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/leaveWaybillNode`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "time": "2020-08-28T07:20:03.788Z",
    //   "urlList": [
    //     "string"
    //   ],
    //   "urlType": 1,
    //   "version": 0,
    //   "waybillNodeId": 0
    // }
  });
}

//拉取货物信息
export function getGoodsInfoBeforeLoad(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/getGoodsInfoBeforeLoad`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

//交货前拉取货物信息
export function getGoodsInfoBeforeDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/getGoodsInfoBeforeDelivery`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

//确认交货
export function confirmDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/confirmDelivery`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

///waybillAction/getGoodsBeforeSign 运单-查询待签收的货物
export function getGoodsBeforeSign(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/getGoodsBeforeSign`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

///waybillAction/getGoodsBeforeSign 运单-签收
export function signOrder(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/signOrder`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

// /waybillAction/confirmLoad

///waybillAction/getGoodsBeforeSign 装货
export function confirmLoad(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/confirmLoad`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

///waybillAction/getGoodsBeforeSign 装货
export function getPageByCondition(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/getPageByCondition`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

//运单-查询待回单的订单
export function getOrderBeforeReceipt(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/getOrderBeforeReceipt`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

//运单-回单
export function receiptWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/receipt`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

// 运单-回单审核获取订单信息
export function getOrderBeforeReceiptReview(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/getOrderBeforeReceiptReview`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

// 运单-回单审核
export function receiptReview(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/receiptReview`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

// 运单-回单复审获取订单信息
export function getOrderBeforeReceiptReReview(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/getOrderBeforeReceiptReReview`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

// 运单-回单复审
export function receiptReReview(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/receiptReReview`,
    method: "post",
    data
    // {
    //   "corpId": 0,
    //   "id": "string",
    //   "plantForm": 0,
    //   "version": 0
    // }
  });
}

// 根据不同操作，拉取可操作的节点列表
export function getNodeListByAction(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/getNodeListByAction`,
    method: "get",
    params
  });
}

//获取车型下拉数据
export function findPageCarModelData(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/findPage`,
    method: "post",
    data
  });
}

// 打印备货单
export function findPrintGoodsInfo(params) {
  return http({
    url: `${host}${E6_MS_TMS_CUSTOMER_DMH_WEB}/api/orderPrint/findPrintInfo`,
    method: "get",
    params
  });
}

// 拉取运单号
export function fetchWaybillNo() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getWaybillNo`,
    method: "get"
  });
}

// 根据车辆id查询装载率等
export function fetchLoadingRateById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/pageQueryLoadingRate`,
    method: "get",
    params
  });
}
// 获取配送类型下拉
export function getDeliveryTypeInfo() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getDeliveryType`,
    method: "get"
  });
}
// 查询外部派车信息
export function findFollowVehicle(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/findFollowVehicle`,
    method: "get",
    params
  });
}
//外部派车信息修改
export function modifyFollowVehicle(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/modifyFollowVehicle`,
    method: "post",
    data
  });
}
